<template>
  <BaseModal
    :heading="$t(`global.actions.edit_${isChore ? 'chore' : 'absence'}`)"
    parentRoute="calendar"
  >
    <AbsenceForm />
  </BaseModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AbsenceForm from '../forms/AbsenceForm.vue';

export default defineComponent({
  components: {
    AbsenceForm,
  },
  computed: {
    isChore() {
      return this.$route.name === 'chore';
    },
  },
});
</script>
